import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'reviews';
const initialState = {
  searchTerm: null,
  reviews: {
    isLoading: false,
    data: {},
    error: null,
  },
  navigationReviews: {
    isLoading: false,
    data: {},
    error: null,
  },
  reviewersList: {
    isLoading: false,
    data: [],
    error: null,
  },
  requestersList: {
    isLoading: false,
    data: [],
    error: null,
  },
  projectsByActiveReviews: {
    isLoading: false,
    data: {},
    error: null,
  },
  reviewMetrics: {
    isLoading: false,
    data: {},
    error: null,
  },
  statusFilter: {
    internalDefault: 'pending_review',
    externalDefault: 'my_pending_reviews',
  },
  filters: {
    projects: [],
    requesters: [],
    reviewers: [],
  },
  sort: {
    element: 'recently_added',
    order: 'asc',
  },
  page: {
    number: 0,
    limit: 20,
  },
  pagination: { pages: 1 },
};

const { reducer, actions: reviewsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    applyPage: (state, { payload }) => {
      state.page.number = payload?.number;
      state.searchTerm = '';
    },

    applyStatusFilter: (state, { payload }) => {
      state.statusFilter = payload;
      state.page.number = 0;
    },

    applyFilter: (state, { payload: { type, value } }) => {
      state.filters[type] = value;
      state.page.number = 0;
    },

    resetFilter: (state) => {
      const user = state.filters.user;
      state.filters = { ...initialState.filters, user };
      state.filters.changed = false;
      state.page.number = 0;
      state.searchTerm = '';
    },

    applySort: (state, { payload: { element, order } }) => {
      state.sort.element = element;
      state.sort.order = order;
    },

    applySearchTerm: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page.number = 0;
    },

    clearFilter: (state, { payload }) => {
      const { type, isMulti = false } = payload;
      state.filters[type] = isMulti ? [] : null;
      state.page.number = 0;
    },

    clearAllFilter: (state, { payload }) => {
      state.page = { ...initialState.page };
      state.filters = {
        ...initialState.filters,
        user: [null],
        changed: false,
      };
      if (payload?.isAll) {
        state.statusFilter = { ...initialState.statusFilter };
      }
      state.page.number = 0;
      state.searchTerm = '';
    },

    setLoadingState: (state, { payload }) => {
      const { key, isLoading } = payload || {};
      if (state[key]) {
        state[key].isLoading = isLoading;
        state[key].error = null;
      }
    },

    fetchSuccess: (state, { payload }) => {
      const { key, data, status } = payload || {};
      if (state[key]) {
        state[key].isLoading = false;
        state[key].data = data;
        state[key].error = null;
        state[key].status = status;
      }
    },

    fetchFailure: (state, { payload }) => {
      const { key, error } = payload || {};
      if (state[key]) {
        state[key].isLoading = false;
        state[key].error = error;
      }
    },
  },
});

export { reviewsActions };
export default reducer;
